module.exports = __webpack_public_path__ + "img/other.788f093.png";